<div class="fx-column">
  <div class="graph-class-container" [style.height.px]="height()">
    @if (!error() && !noData()) {
      <div id="graphclassdiv" #graphclassdiv class="graph-class" [style.height.px]="height()"></div>
    }
    @if (loading() && !error() && !noData()) {
      <mat-progress-spinner class="main-spinner" mode="indeterminate" diameter="25"></mat-progress-spinner>
    }
    @if (error()) {
      <div class="fx-column align-items-center justify-content-center">
        <mat-icon class="red mb-5" fontSet="material-icons-outlined">error</mat-icon>
        <span class="text light">{{ 'DOCUMENTS_REPORT.ERROR' | translate }}</span>
      </div>
    }
    @if (!loading() && noData()) {
      <div class="fx-column align-items-center justify-content-center">
        <span class="text light">{{ 'DOCUMENTS_LIST.SEARCH_NO_DOCUMENTS' | translate }}</span>
      </div>
    }
  </div>
</div>
